// 前年度ボタン
export function prevAccessNumber () {
  $('#prev_access_number').click(function () {
    beforeAjaxCommunication(this);
  })
}

// 本年度ボタン
export function currentAccessNumber () {
  $('#current_access_number').click(function () {
    beforeAjaxCommunication(this);
  })
}

// 次年度ボタン
export function nextAccessNumber () {
  $('#next_access_number').click(function () {
    beforeAjaxCommunication(this);
  })
}

// ajax通信の処理
function beforeAjaxCommunication (element) {
  // 選択した年度を取得
  let selectFiscalYear = element.dataset.fiscalYear;
  // URLを取得
  let href = document.getElementById('current_access_number').dataset.href;
  let url = new URL(href);
  url.searchParams.set('fiscal_year', selectFiscalYear);

  let xmlHttpRequest = new XMLHttpRequest();
  xmlHttpRequest.open('GET', url)
  xmlHttpRequest.send();

  xmlHttpRequest.onreadystatechange = function() {
    if (xmlHttpRequest.readyState === 4) {
      if (xmlHttpRequest.status === 200) {
        // 表示年度を切り替え
        document.querySelector('h3 span.fiscal_year').textContent = selectFiscalYear;
        // 前年度をセット
        document.getElementById('prev_access_number').dataset.fiscalYear = parseInt(selectFiscalYear)-1;
        // 次年度をセット
        document.getElementById('next_access_number').dataset.fiscalYear = parseInt(selectFiscalYear)+1;
        // リストを差し替え
        document.querySelector('dl.base-list').innerHTML = xmlHttpRequest.responseText;
      } else {
        console.log('失敗')
      }
    }
  };
}